import { InvalidCredentialsError, UnexpectedError } from "../../domain/errors";
import { AccountModel } from "../../domain/models";
import { LoadAccountByTokenParams } from "../../domain/usecases/load-account-by-token";
import { HttpClient, HttpStatusCode } from "../protocols/http";

export class LoadAccountByToken implements LoadAccountByToken {
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient
  ) {}
  async loadByToken(params: LoadAccountByTokenParams): Promise<AccountModel> {
    const httpResponse = await this.httpClient.request({
      url: this.url,
      method: "get",
      params: params,
    });
    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.unauthorized:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError();
    }
  }
}
